import React, { useEffect, useState } from "react";
import ContentController from "../../apis/controller/content.controller";
import PageTitle from "../PageTitle";



function PrivacyPolicy() {
    const [privacy, setPrivacy] = useState();
    const [breadCrumbs, setBreadcrumbs] = useState();
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        getPrivacy();
        window.scrollTo(0, 0);
    }, []);

    const getPrivacy = async () => {
        setLoader(true);
        let res = await new ContentController().privacyPolicy();
        if (res && res.status) {
            setPrivacy(res.page);
            setBreadcrumbs(res.breadcrumb);
        }
        setLoader(false);
    };
    return (
        <div>
            {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
            {privacy && <div className="terms_section top_space">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xxl-12 col-xxl-12 col-xxl-12 col-xxl-12 col-xxl-12">
                            <div className="terms_wrap text-center">
                                <div className="detail_area">
                                    <h1>{privacy.title}</h1>
                                    <div dangerouslySetInnerHTML={{ __html: privacy.description }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    );
}

export default PrivacyPolicy;